import React from 'react';

import { ProgressContainer, Progress } from './styles';

export default function ProgressBar({ percent, barType }) {
  return (
    <ProgressContainer>
      <Progress aria-valuemin="0" aria-valuemax="100" percent={percent} barType={barType} />
    </ProgressContainer>
  );
}
